<template>
  <mdb-container class="gp-has-header">
    <div v-if="memberInfo">
      <mdb-card>
        <mdb-card-body>
          <img :src="memberInfo.avatar" style="width:33%; float: left"/>
          <h2><i><b>{{memberInfo.name}}</b></i></h2>
          <h4>{{memberInfo.groupName}}</h4>
          <h5>Member Since {{memberInfo.memberSince}}</h5>
          <h6>Expires {{memberInfo.expirationDate}}</h6>
          <avatar :avatar="memberInfo.groupAvatar" :size="150" container-class=""/>
        </mdb-card-body>
      </mdb-card>
    </div>
  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {mapState} from 'vuex'
import Avatar from "../common/Avatar";

import {mdbCard, mdbCardBody, mdbContainer} from 'mdbvue';

export default {
  name: "public-id-card",
  components: {
    mdbContainer,
    mdbCard,
    mdbCardBody,
    Avatar
  },
  computed: mapState({
                       currentGroup: state => state.currentGroup
                     }),
  data() {
    return {
      memberInfo: {}
    }
  },
  mounted() {
    document.title = "ID Card"
    this.loadMember()
  },
  methods: {
    loadMember() {
      api.get("/member/publicIdCard?code=" + this.$route.query.code).then(
        (results) => {
          this.memberInfo = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};

</script>
